import { useMutation, MutationHookOptions } from '@apollo/react-hooks';
import { DEPRECATE_AUTH_PROVIDER_MUTATION } from '@frontend/app/queries';
import {
  DeprecateAuthProviderMutation,
  DeprecateAuthProviderMutationVariables,
} from '@frontend/app/queries/types/DeprecateAuthProviderMutation';

type TOptions = MutationHookOptions<DeprecateAuthProviderMutation, DeprecateAuthProviderMutationVariables>;

export const useDeprecateAuthProviderMutation = (options: TOptions = {}) =>
  useMutation<DeprecateAuthProviderMutation, DeprecateAuthProviderMutationVariables>(
    DEPRECATE_AUTH_PROVIDER_MUTATION,
    options,
  );
